import script from "./WizardTransferCompleteStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardTransferCompleteStep.vue?vue&type=script&setup=true&lang=js"

import "./WizardTransferCompleteStep.vue?vue&type=style&index=0&id=5e9563a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9563a8"]])

export default __exports__